import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextIndentRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTextIndentRight"><Path fillRule="evenodd" clipRule="evenodd" d="M15 5H2V7H15V5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M15 11H2V13H15V11Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M15 17H2V19H15V17Z" fill="currentColor"/><Path d="M22 15.5V8.5L17 12L22 15.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTextIndentRight;
